import EmployeeAvatar from 'components/assign/EmployeeAvatar';
import MentionText from 'components/comments/MentionText';
import useHomeText from 'hooks/useHomeText';

const fullName = (person) =>
  [person?.firstname, person?.lastname].filter(Boolean).join(' ');

/**
 * A comment that names the user: its author, `when` it was written, the task
 * it is on and its text, the user's name in colour (`me`); a dot while the
 * task is unread. The whole line opens the task (`onOpen`).
 */
const MentionItem = ({ mention, when, me, onOpen }) => {
  const { text } = useHomeText();
  return (
    <button
      type="button"
      onClick={() => onOpen(mention)}
      className="flex w-full gap-3 rounded-lg px-2 py-2 text-left transition-colors hover:bg-gray-50"
    >
      <EmployeeAvatar employee={mention.author} size={28} />
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <span className="truncate text-sm font-medium text-gray-900">
            {fullName(mention.author)}
          </span>
          {mention.unread && (
            <span
              role="img"
              aria-label={text('mentions.unread')}
              className="block h-1.5 w-1.5 shrink-0 rounded-full bg-yellow-500"
            />
          )}
          <span className="ml-auto shrink-0 text-xs text-gray-500">{when}</span>
        </span>
        <span className="block truncate text-xs text-gray-500">
          {text('mentions.inTask', { task: mention.task.title })}
        </span>
        <span className="mt-0.5 line-clamp-2 text-sm text-gray-700">
          <MentionText
            text={mention.body}
            people={[me, mention.author].filter(Boolean)}
          />
        </span>
      </span>
    </button>
  );
};

// Grey lines where the mentions will land, while they are read.
export const MentionSkeleton = ({ rows = 2 }) => (
  <div className="flex animate-pulse flex-col gap-3 py-1" aria-busy="true">
    {Array.from({ length: rows }, (_, row) => (
      <div key={row} className="flex gap-3 px-2">
        <span className="size-7 shrink-0 rounded-full bg-gray-200" />
        <span className="flex flex-1 flex-col gap-2">
          <span className="h-3 w-2/5 rounded bg-gray-200" />
          <span className="h-3 w-4/5 rounded bg-gray-200" />
        </span>
      </div>
    ))}
  </div>
);

export default MentionItem;
